
import { getLiveMatches } from "data/Querys"
import { useQuery } from 'react-query'
import Loader from 'components/general/Loader'
import ScoresLiveCard from "components/common/ScoresLiveCard";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";



const LiveTeamMatches = () => {
  const { mirs_competition, mirs_language, mirs_discipline } = useUrlFriendlyToParameters()
  // load getting ready or running units
  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['liveTeamMatches', mirs_competition, mirs_language, mirs_discipline, undefined, "T"],
      queryFn: getLiveMatches,
      refetchInterval: 0,
      cacheTime: 5000,
      staleTime: Infinity,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
    }
  );
  if (isError) { return <div >No data available</div>; }
  if (isLoading) { return <Loader />; }

  const config = {
    team: true
  }

  return (<>
    <h2>Under construction. Don't test</h2>
    <div className="scores-today-container">
      {data && data?.map(item => {
        return (<ScoresLiveCard data={item} key={item?.eventUnit?.code} config={config} />)
      })}
    </div>
  </>
  );
}

export default LiveTeamMatches;